import { render, staticRenderFns } from "./SupervisorsInfo.vue?vue&type=template&id=38a037bc"
import script from "./SupervisorsInfo.vue?vue&type=script&lang=js"
export * from "./SupervisorsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports